import { defineFcm } from '../shared/factory';

export const FCM_PROMOTIONS_INELIGIBLE_PETITION_REFUND_LIMIT = defineFcm('promotions_ineligible_petition_refund_limit')
	.asNumber()
	.withDefault(100000)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'promotion-service',
		context: 'Automated Refunds on Closed / Hidden Petitions - Promotion Service',
		description: `Configures the maximum USD Cents amount in unfulfilled promotions that will automatically be refunded
			by the Automated Refunds on Closed / Hidden Petitions tool.
			Amounts here should be configured in USD CENTS, ie. $1000 USD -> 100000
			Petitions with an unfulfilled promotion amount less than this limit will be automatically refunded.
			Petitions with an unfulfilled promotion amount greater than this limit will create a Jira ticket in:
			https://change.atlassian.net/jira/core/projects/PR/board`,
	});
